/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function createHideOnClickOutsideAction(_ref) {
  var getOverlayNode = _ref.getOverlayNode,
    getActiveTargetNode = _ref.getActiveTargetNode,
    onHide = _ref.onHide;
  return function (event) {
    var node = event.target;
    var activeTargetNode = getActiveTargetNode();
    var overlayNode = getOverlayNode();
    if (!activeTargetNode || !overlayNode) {
      return null;
    }
    if (overlayNode !== node && !overlayNode.contains(node) && activeTargetNode !== node && !activeTargetNode.contains(node)) {
      onHide(event, {
        target: null
      });
    }
  };
}
var _default = createHideOnClickOutsideAction;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Overlay/src/eventManager/createHideOnClickOutsideAction.js
// module id = 724
// module chunks = 0